import {
    VerificationTransactionDetailsTrustScoreBreakdown,
    FormattedVerificationTransactionDetailsTrustScoreBreakdown
} from "@idw-types/data/verification-transaction-details";
import { safelyParseIntFromString } from "@utils/string-util";

export const formatVerificationTransactionDetailsTrustScoreBreakdowns = (
    assertionScoreBreakdowns: Array<VerificationTransactionDetailsTrustScoreBreakdown>,
): Array<FormattedVerificationTransactionDetailsTrustScoreBreakdown> => {
    return assertionScoreBreakdowns.map(breakdown => formatVerificationTransactionDetailsTrustScoreBreakdown(breakdown));
};

export const formatVerificationTransactionDetailsTrustScoreBreakdown = (
    assertionScoreBreakdown: VerificationTransactionDetailsTrustScoreBreakdown,
): FormattedVerificationTransactionDetailsTrustScoreBreakdown => {
    let dateCreated = null;
    if (assertionScoreBreakdown.dateCreated) {
        dateCreated = new Date(parseInt(assertionScoreBreakdown.dateCreated));
    }

    return {
        apiKey: assertionScoreBreakdown.apiKey,
        apWeightsTotal: assertionScoreBreakdown.apWeightsTotal,
        asi: assertionScoreBreakdown.asi,
        dateCreated: dateCreated,
        id: assertionScoreBreakdown.id,
        modifiedRawScore: safelyParseIntFromString(assertionScoreBreakdown.modifiedRawScore),
        scoreModifierList: assertionScoreBreakdown.scoreModifierList,
        scoreModifierValue: safelyParseIntFromString(assertionScoreBreakdown.scoreModifierValue),
        trustScore: safelyParseIntFromString(assertionScoreBreakdown.trustScore),
        trustScoreRangeMax: safelyParseIntFromString(assertionScoreBreakdown.trustScoreRangeMax),
        trustScoreRangeMin: safelyParseIntFromString(assertionScoreBreakdown.trustScoreRangeMin),
        unmodifiedRawScore: safelyParseIntFromString(assertionScoreBreakdown.unmodifiedRawScore),
        userAcquiredScoreHistoryID: assertionScoreBreakdown.userAcquiredScoreHistoryID,
        userID: assertionScoreBreakdown.userID,
        weightedScoresTotal: safelyParseIntFromString(assertionScoreBreakdown.weightedScoresTotal)
    };
};